import React from "react";
import { Card } from "../ui/card";
import { Info } from "lucide-react";

export default function NotificationExamples() {
    const examples = [
        {
            title: "Personal Message",
            description: "When an admin sends you a direct message",
            example: "1 message from Admin",
            color: "border-blue-200 bg-blue-50"
        },
        {
            title: "Community Digest",
            description: "Accumulated community activity",
            example: "312 community · 1 admin message",
            color: "border-purple-200 bg-purple-50"
        },
        {
            title: "Reply to Your Question",
            description: "Someone responds to your post",
            example: "Someone replied to your question",
            color: "border-emerald-200 bg-emerald-50"
        }
    ];

    return (
        <Card className="border-slate-200 bg-gradient-to-br from-slate-50 to-white">
            <div className="p-5">
                <div className="flex items-center gap-2 mb-4">
                    <Info className="w-5 h-5 text-blue-500" />
                    <h3 className="font-semibold text-slate-900">Notification Examples</h3>
                </div>

                <div className="space-y-3">
                    {examples.map((example, index) => (
                        <div key={index} className={`border-2 rounded-lg p-3 ${example.color}`}>
                            <div className="flex items-start justify-between gap-3 mb-2">
                                <div className="flex-1">
                                    <h4 className="font-medium text-slate-900 text-sm mb-0.5">
                                        {example.title}
                                    </h4>
                                    <p className="text-xs text-slate-600">
                                        {example.description}
                                    </p>
                                </div>
                            </div>
                            <div className="bg-white rounded px-3 py-2 text-sm font-medium text-slate-700 border border-slate-200">
                                "{example.example}"
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <p className="text-xs text-amber-800 leading-relaxed">
                        <strong>Anti-Spam Protection:</strong> Community messages are never sent individually.
                        They're combined into a single digest to keep your notifications clean and professional.
                    </p>
                </div>
            </div>
        </Card>
    );
}
